export const DELIVERY_DATES_RESET_STATE = 'DELIVERY_DATES_RESET_STATE';
export const DELIVERY_DATES_CURRENT_ITEM = 'DELIVERY_DATES_CURRENT_ITEM';

export const DELIVERY_DATES_REQUEST_LOADING = 'DELIVERY_DATES_REQUEST_LOADING';
export const DELIVERY_DATES_REQUEST_SUCCESS = 'DELIVERY_DATES_REQUEST_SUCCESS';
export const DELIVERY_DATES_REQUEST_FAILED = 'DELIVERY_DATES_REQUEST_FAILED';

export const DELIVERY_DATES_CURRENT_ACTION = 'DELIVERY_DATES_CURRENT_ACTION';
export const DELIVERY_DATES_RESET_ACTION = 'DELIVERY_DATES_RESET_ACTION';